var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:`gl-breadcrumb-item gl-breadcrumb-item-${_vm.size}`},[_c('gl-link',{attrs:{"href":_vm.href,"to":_vm.to,"aria-current":_vm.ariaCurrent,"variant":_vm.$options.linkVariantUnstyled}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }